import ds from './DataSourceService'

const baseUrl = '/apartment-orientations'

const getApartmentOrientationById = id => {
  return ds.apiClientThinkHome.get(baseUrl + '/' + id)
}

const addApartmentOrientation = apartmentOrientation => {
  return ds.apiClientThinkHome.post(baseUrl, apartmentOrientation)
}

const updateApartmentOrientation = apartmentOrientation => {
  return ds.apiClientThinkHome.patch(
    baseUrl + '/' + apartmentOrientation.id,
    apartmentOrientation
  )
}

const deleteApartmentOrientation = apartmentOrientation => {
  return ds.apiClientThinkHome.delete(baseUrl + '/' + apartmentOrientation)
}
export default {
  getApartmentOrientationById,
  addApartmentOrientation,
  updateApartmentOrientation,
  deleteApartmentOrientation
}
